import React from 'react';
import classNames from 'classnames';
import {ReactComponent as Icon} from 'images/common/CloseModal.svg';

export default class CloseIcon extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon close', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
